import React, { useState, useEffect, useRef } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import ReactDOM from 'react-dom'
import ModalWindow from '../../../layout/modalwindow/ModalWindow'
import AutoCompleteList from '../../../layout/AutoCompleteList'
import RegisterProductUnitFormStyle from './css/RegisterProductUnitFormStyle'
import { filterItemsStartsWith } from '../../../utilities/utilities'

function RegisterProductUnitForm(props) {
  const { app, getWarehouses, updateUnit, findBarcode, units, unitNames, mode, unitID } = props
  const modalFormContainer = document.getElementById('modal-form-container')
  const unitNameRef = useRef(null)
  const idRef = useRef(null)
  const retailPriceRef = useRef(null)
  const unitContentsQuantityRef = useRef(null)
  const [activeInput, setActiveInput] = useState(false)
  const [inputError, setInputError] = useState(null)
  const [keyPressed, setKeyPressed] = useState('')
  const [itemClicked, setItemClicked] = useState(false)
  const [unitNamesList, setUnitNamesList] = useState([])
  const [unit, setUnit] = useState({
    id: (new Date(app.getClientDateTime()).getTime()).toString(),
    unit_type: units.length ? 'Container' : 'Base',
    unit_name: '',
    unit_contents: [],
    unit_content: '',
    container_type_display: units.length ? 'flex' : 'none',
    contents_quantity: 0,
    description: '',
    vatable: true,
    fractional: false,
    critical_level_quantity: 0.00,
    capital_amount: 0.00,
    wholesale_price: 0.00,
    retail_price: 0.00,
    percent_off: 0.00,
    percent_off_remarks: '',
    inventory: 0,
    warehouses: [],
    status: 'Active'
  })

  const showUnitNameErrorMessageBox = () => {
    ReactDOM.render (
      <ModalWindow
        id='mw-child'
        height='30'
        header="Adding Unit Error"
        footer={null}>
        <div className='messagebox'>
          <div className='messagebox-content'>
            <div style={{marginBottom: '20px'}}>Don't use 'x' as a unit name</div>
            <div>Change it a little bit to make it different then try again.</div>
          </div>
          <div className='button-container'>
            <button
              onClick={() => {
                unitNameRef.current.focus()
                ReactDOM.unmountComponentAtNode(document.getElementById('mw-parent')) 
              }}
              className='pospro-action-btn top-anchor'>
              Ok
            </button>
          </div>
        </div>
      </ModalWindow>,
      document.getElementById('mw-parent')
    )
  }

  const showUnitNameExistErrorMessageBox = () => {
    ReactDOM.render (
      <ModalWindow
        id='mw-child'
        header='Adding Unit Error'
        footer={null}>
          <div className='messagebox'>
            <div className='messagebox-content'>
              <div style={{marginBottom: '20px'}}>This unit description already exist</div>
              <div>Change it a little bit to make it different then try again.</div>
            </div>
            <div className='button-container'>
              <button
                onClick={() => {
                  unitNameRef.current.focus()
                  ReactDOM.unmountComponentAtNode(document.getElementById('mw-parent'))
                }}
                className='pospro-action-btn top-anchor'>
                Ok
              </button>
            </div>
          </div>
      </ModalWindow>,
      document.getElementById('mw-parent')
    )
  }

  const setUnitName = (value) => {
    value = value.trim()

    if (value.toLowerCase() === 'x') {
      showUnitNameErrorMessageBox()
      return //alert('Dont use x')
    }
    if (unit.unit_type === 'Container') {
      setUnit({...unit,
        unit_name: value,
        description: `${value}(${unit.contents_quantity}x${unit.unit_content})`
      })
    } else
      setUnit({ ...unit, unit_name: value, description: value })
  }

  const onClickClose = (e) => ReactDOM.unmountComponentAtNode(modalFormContainer)

  const onClickAddUnit = async (e) => {
    const findUnitDescription = (unit_description) => {
      //const unit_to_edit = units.find(unit => unit.id === parseInt(unitID))
      const unit_to_edit = units.find(unit => unit.id === unitID)
      if (mode === 'edit') {
        //const filtered_units = units.filter(unit => unit.description !== units[unitID].description)
        const filtered_units = units.filter(unit => unit.description !== unit_to_edit.description)
        return (filtered_units.filter(unit => unit.description === unit_description).length > 0)
      } else
        return (units.filter(unit => unit.description === unit_description).length > 0)
    }

    // Validate unit name
    if (!unit.unit_name.trim()) {
      setInputError('Please input a Unit Name.')
      unitNameRef.current.focus()
      return
    }

    // Validate unit contents quantity
    if ((isNaN(unit.contents_quantity) || (unit.contents_quantity === 0)) && (unit.unit_type === 'Container')) {
      setInputError('Contents Quantity cannot be empty or 0.')
      unitContentsQuantityRef.current.focus()
      return
    }

    // Validate ID/barcode
    // Check if barcode exist, if barcode is not the same as the one being edited
    // otherwise its perfectly valid to update a unit which unit.id is already exist
    if (unit.id !== unitID) {
    //if (unit.id !== parseInt(unitID)) {
      const barcode = await findBarcode(unit.id)
      if (barcode) {
        setInputError(`barcode ${barcode.id} is already in use.`)
        idRef.current.focus()
        return
      }
    }

    // Validate Retail Price
    // Retail Price cannot be zero (0)
    if (unit.retail_price === 0) {
      setInputError('Retail Price cannot be 0')
      retailPriceRef.current.focus()
      return
    }

    // If everything is good then proceed here
    // Check if current unit description already exist
    // Filter the units to not include the unit_description prior to edit
    if (findUnitDescription(unit.description)) {
      showUnitNameExistErrorMessageBox()
    } else {
      // Delete unnecessary elements
      delete unit.unit_contents
      delete unit.container_type_display

      updateUnit(unit, unitID, mode)
      onClickClose()
    }
  }

  const setButtonCaption = () => (mode === 'add') ? (<>&nbsp;Add</>) : (<>&nbsp;Update</>)

  const onKeyDown = (e) => {
    switch(e.key) {
      case 'Enter':
      case 'Tab':
      case 'Escape':
        setUnitNamesList([])
        ReactDOM.unmountComponentAtNode(document.getElementById(e.target.name+'-acl-container'))
        break;
      default:
        setKeyPressed(e.key)
    }
  }

  const onChangeUnitId = (e) => {
    if (!(e.target.value))
      setUnit({ ...unit, id: (new Date(app.getClientDateTime()).getTime()).toString() })
    else {
      let barcode = e.target.value
      if (!isNaN(barcode)) setUnit({ ...unit, id: barcode })
    }
  }

  const onBlurUnitId = (e) => {
    // Complete the barcode to 13 digit if it is not by padding 0's
    let barcode = e.target.value

    const barcode_diff = (13 - barcode.length)
    if (barcode_diff !== 0) barcode = barcode.concat(Array(barcode_diff + 1).join('0'))
    if (!isNaN(barcode)) setUnit({ ...unit, id: barcode })

  }

  const onChangeUnitName = (e) => {
    setActiveInput(e.target.name)
    setInputError(false)
    setUnitNamesList(filterItemsStartsWith(unitNames, e.target.value))
    setUnitName(e.target.value)
  }

  const onChangeContentsQuantity = (e) => {
    setUnit({
      ...unit, [e.target.name]: (e.target.value) ? parseFloat(e.target.value) : '',
      description: `${unit.unit_name}(${e.target.value}x${unit.unit_content})`
    })
  }
  const onBlurContentsQuantity = (e) => {
    if (e.target.value === '')
      setUnit({
        ...unit,
        [e.target.name]: 1,
        description: `${unit.unit_name}(1x${unit.unit_content})`
      })
  }

  const onChangeUnitContents = (e) => setUnit({
    ...unit, [e.target.name]: e.target.value,
    description: `${unit.unit_name}(${unit.contents_quantity}x${e.target.value})`
  })

  const onChangeNumber = (e) => {
    setUnit({ ...unit, [e.target.name]: (e.target.value) ? parseFloat(e.target.value) : '' })
  }

  const onBlurNumber = (e) => { if (e.target.value === '') setUnit({ ...unit, [e.target.name]: 0 }) }

  const init = async () => {
    const  mainWarehouse = (await getWarehouses(app)).find(wh => wh.name === 'Main Warehouse')

    if (mode === 'add')
      setUnit({...unit,
        unit_contents: units.map(unit => unit.description),
        unit_content: units.map(unit => unit.description)[0] || '',
        // set initial inventory for main warehouse (the default)
        warehouses: [{warehouse_id: mainWarehouse._id, quantity: 0}]
      })
    else { // edit
      const unit_to_edit = units.find(unit => unit.id === unitID)
      const unitDescriptions = units.filter(unit => unit.id !== unitID).map(unit => unit.description)
      setUnit({...unit,
        container_type_display: (unit_to_edit.unit_type === 'Container' ? 'flex' : 'none'),
        unit_contents: unitDescriptions,
        ...unit_to_edit
      })
    }
    unitNameRef.current.focus()
  }

  useEffect(() => {
    init()
    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (activeInput)
      if (unitNamesList.length > 0)
        ReactDOM.render(
          <AutoCompleteList
            valueSetter={(value) => setUnitName(value)}
            keyPressed={keyPressed}
            setItemClicked={setItemClicked}
            items={unitNamesList}
          />, document.getElementById(activeInput+'-acl-container')
        )
      else {
        ReactDOM.unmountComponentAtNode(document.getElementById(activeInput+'-acl-container'))
      }

    if (itemClicked) {
      setUnitNamesList([])
      setItemClicked(false)
    }
    // keypressed Hack reset
    if (keyPressed === 'ArrowUp' || keyPressed === 'ArrowDown') setKeyPressed('')

    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [keyPressed, unit.unit_name, itemClicked])

  return (
    <React.Fragment>
      <div id='messagebox-container'></div>
      <div id='add-unit-form'>
        <div className="add-unit-form">
          <div className="form-group" id="unit-type-container">
            <label htmlFor="unit-type">Unit Type</label>
            <div className='input-container'>
              <input
                className='top-anchor'
                readOnly = 'readOnly'
                name="unit-type"
                id="unit-type"
                value={unit.unit_type}
                style={{backgroundColor: 'whitesmoke'}}
              />
            </div>
          </div>

          <div className="form-group" id="unit-type-container">
            <label htmlFor="unit-type">ID/Barcode</label>
            <div className='input-container'>
              <input
                ref={idRef}
                placeholder="ID/Barcode"
                name="unit_id"
                id="unit-id"
                type="text"
                value={unit.id}
                onChange={onChangeUnitId}
                onBlur={onBlurUnitId}
              />
            </div>
          </div>

          <div className="form-group" id="unit-name-container">
            <label htmlFor="unit-name">Unit Name</label>
            <div className='input-container'>
              <input
                ref={unitNameRef}
                autoComplete='off'
                id="unit-name"
                type="text"
                placeholder="Example: Pcs, Box, Liter, etc.."
                name="unit_name"
                onChange={onChangeUnitName}
                onKeyDown={onKeyDown}
                value={unit.unit_name}
              />
              <div id='unit_name-acl-container' className='acl-container'></div>
            </div>
          </div>

          <div className="form-group" style={{display: unit.container_type_display}}>
            <label htmlFor="unit-contents">Contents</label>
            <div className='input-container'>
              <select
                id="select-unit-contents"
                name="unit_content"
                onChange={onChangeUnitContents}
                value={unit.unit_content}
                style={{display: unit.select_unit_contents_display}}>
                {
                  unit.unit_contents.map((unit_content, index) => (
                    <option key={index}>{unit_content}</option>
                  ))
                }
              </select>
            </div>
          </div>

          <div className="form-group" style={{display: unit.container_type_display}}>
            <label htmlFor="contents-quantity">Contents Quantity</label>
            <div className='input-container'>
              <input
                ref={unitContentsQuantityRef}
                id="contents-quantity"
                type="number"
                min='0'
                placeholder="Contents Quantity"
                name="contents_quantity"
                onChange={onChangeContentsQuantity}
                onBlur={onBlurContentsQuantity}
                value = {unit.contents_quantity}
              />
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="unit-description">Description</label>
            <div className='input-container'>
              <input
                id="unit-description"
                readOnly="readOnly"
                type="text"
                placeholder="Description"
                name="description"
                value={unit.description}
                style={{backgroundColor: 'whitesmoke'}}
              />
            </div>
          </div>
          <div className="form-group">
            <label>Vatable?</label>
            <div className='input-container'>
              <div id="item-unit-vatable-container">
                <div id="item-unit-vatable-yes-container">
                  <label htmlFor="vatable-yes">Yes</label>
                  <input
                    id="vatable-yes"
                    type="radio"
                    name="vatable"
                    value={true}
                    checked={unit.vatable}
                    onChange={(e) => setUnit({...unit, vatable: true})}
                  />
                </div>
                <div id="item-unit-vatable-no-container">
                  <label htmlFor="vatable-no">No</label>
                  <input
                    id="vatable-no"
                    type="radio"
                    name="vatable"
                    value={false}
                    checked={!unit.vatable}
                    onChange={(e) => setUnit({...unit, vatable: false})}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="form-group">
            <label>Accepts Fractional Quantity?</label>
            <div className='input-container'>
              <div id="item-unit-fractional-container">
                <div id="item-unit-fractional-yes-container">
                  <label htmlFor="fractional-yes">Yes</label>
                  <input
                    id="fractional-yes"
                    type="radio"
                    name="fractional"
                    value={true}
                    checked={unit.fractional}
                    onChange={(e) => setUnit({...unit, fractional: true})}
                  />
                </div>
                <div id="item-unit-fractional-no-container">
                  <label htmlFor="fractional-no">No</label>
                  <input
                    id="fractional-no"
                    type="radio"
                    name="fractional"
                    value={false}
                    checked={!unit.fractional}
                    onChange={(e) => setUnit({...unit, fractional: false})}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="form-group" id="unit-name-container">
            <label htmlFor="critical-level-quantity">Critical Level Quantity</label>
            <div className='input-container'>
              <input
                id="critical-level-quantity"
                type="number"
                min='0'
                placeholder="Critical Level Quantity"
                name="critical_level_quantity"
                onChange={onChangeNumber}
                onBlur={onBlurNumber}
                value={unit.critical_level_quantity}
              />
            </div>
          </div>

          <div className="form-group">
            <label htmlFor='capital-amount'>Capital Amount</label>
            <div className='input-container'>
              <input
                id="capital_amount"
                type="number"
                min='0'
                placeholder="Capital Amount"
                name="capital_amount"
                onChange={onChangeNumber}
                onBlur={onBlurNumber}
                value={unit.capital_amount}
              />
            </div>
          </div>
          <div className="form-group">
            <label htmlFor='whole-sale-price'>Wholesale Price</label>
            <div className='input-container'>
              <input
                id="wholesale-price"
                type="number"
                min='0'
                placeholder="Wholesale Price"
                name="wholesale_price"
                onChange={onChangeNumber}
                onBlur={onBlurNumber}
                value={unit.wholesale_price}
              />
            </div>
          </div>
          <div className="form-group">
            <label htmlFor='retail-price'>Retail Price</label>
            <div className='input-container'>
              <input
                ref={retailPriceRef}
                id="retail-price"
                type="number"
                min='0'
                placeholder="Retail Price"
                name="retail_price"
                onChange={onChangeNumber}
                onBlur={onBlurNumber}
                value={unit.retail_price}
              />
            </div>
          </div>

          <div className="form-group">
            <label htmlFor='retail-price'>Percent Off</label>
            <div className='input-container'>
              <input
                id="percent-off"
                type="number"
                min='0'
                placeholder="Percent Off"
                name="percent_off"
                onChange={onChangeNumber}
                onBlur={onBlurNumber}
                value={unit.percent_off}
              />
            </div>
          </div>

          <div className="form-group">
            <label htmlFor='retail-price'>Percent Off Remarks</label>
            <div className='input-container'>
              <input
                id="percent-off-remarks"
                type="text"
                placeholder="Example: Christmas Sale, Big Day Sale, etc.."
                name="percent_off_remarks"
                onChange={(e) => { setUnit({...unit, [e.target.name]: e.target.value}) }}
                value={unit.percent_off_remarks}
              />
            </div>
          </div>

          <div className="form-group">
            <label htmlFor='item-unit-status'>Status</label>
            <div className='input-container'>
              <div id="item-unit-status-container">
                <div id="unit-status-active-container">
                  <label htmlFor="unit-status-active">Active</label>
                  <input
                    id="unit-status-active"
                    type="radio"
                    name="unit-status"
                    value="Active"
                    checked={unit.status === 'Active'}
                    onChange={(e) => setUnit({...unit, status: 'Active'})}
                  />
                </div>
                <div id="unit-status-inactive-container">
                  <label htmlFor="unit-status-inactive">In-active</label>
                  <input
                    id="unit-status-inactive"
                    type="radio"
                    name="unit-status"
                    value="Inactive"
                    checked={unit.status === 'Inactive'}
                    onChange={(e) => setUnit({...unit, status: 'Inactive'})}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="button-unit">
          {
            inputError ?
              <div className='item-error-text'>
                <FontAwesomeIcon icon='exclamation-circle'/>
                &nbsp;{inputError}
              </div> : null
          }
          <button
            id="modal-add-unit-button"
            className="pospro-action-btn"
            type="button"
            onClick={onClickAddUnit}>
            <FontAwesomeIcon icon='save'/>{setButtonCaption()}
          </button>
          <button
            id="modal-close-adding-unit-button"
            className="pospro-action-btn bottom-anchor"
            type="button"
            onClick={onClickClose}>
            <FontAwesomeIcon icon='times'/>&nbsp;Close
          </button>
        </div>
      </div>
      <RegisterProductUnitFormStyle />
    </React.Fragment>
  )
}

export default React.memo(RegisterProductUnitForm)